import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=31c39508&"
import script from "./Clinic.vue?vue&type=script&lang=js&"
export * from "./Clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports